<template>
  <div class="agreementRelet">
      <div class="detail">
        <h3 class="T-title">1、续租须知：</h3>
        <div class="txt">
         			若需续租，可在距离还车时间2小时前通过大方租车APP或支付宝小程序在线申请续租，也可在距离还车时间4小时前致电客服400-666-8818申请续租。单次续租时间不能超过29天，申请续租能否成功视车辆的库存情况而定，如申请续租失败请按照系统提示操作或联系租车门店。续租订单需在30分钟内完成支付，支付成功后立即生效，超过30分钟未支付自动取消，需按照原订单的还车时间还车。每个订单最多可连续在线申请续租3次，超过3次仍需续租，请联系租车门店。
        </div>
        <h3 class="T-title">2、续租费用：</h3>
        
        <div class="txt">a) 续租费用以续租订单显示为准，具体费用及计费规则如下：</div>
        <div class="tab">
          <div class="row">
            <div class="key">车辆租金</div>
            <div class="value">续租天数×车辆租金单价</div>
          </div>
          <div class="row">
            <div class="key">基本保障服务费</div>
            <div class="value">续租天数×基本保障服务费单价</div>
          </div>
          <div class="row">
            <div class="key">超时费</div>
            <div class="value">
              <div>延迟还车需提前24小时联系租车门店，在门店的营业时间内办理还车手续</div>
              <div>·延迟1小时（不含）内还车，不额外收费；</div>
              <div>·延迟1小时（含）至4小时（含）还车，按超时费标准计费：所租车辆基本保障服务费×超时时间（小时），具体金额以系统显示为准；</div>
              <div>·延迟4小时以上还车，按1天（24小时）续租标准收费。</div>
            </div>
          </div>
          <div class="row">
            <div class="key">夜间服务费</div>
            <div class="value">
              <div>·原订单已支付还车时的夜间服务费，续租订单不在夜间还车，合计费用里减去原订单的此项费用；</div>
              <div>·原订单已支付还车时的夜间服务费，续租订单在夜间还车，不重复收取此项费用；</div>
              <div>·原订单未支付还车时的夜间服务费，续租订单在夜间还车，合计费用里加收此项费用。</div>
            </div>
          </div>
          <div class="row">
            <div class="key">驾无忧保障服务费</div>
            <div class="value">
              <div>驾无忧保障服务按续租天数计费：续租天数×驾无忧保障服务费单价</div>
              <div>·原订单购买了驾无忧保障服务，则续租订单必须购买；</div>
              <div>·原订单未购买驾无忧保障服务，则续租订单不能购买。</div>
            </div>
          </div>
        </div>

        <div class="txt">b) 续租订单不可参加优惠活动。</div>
        <div class="txt">c）续租租期如在节假日，则需满足节假日起租天数的规则才能成功申请续租。</div>
        
        <div class="T-title">3、其他费用：</div>
        <div class="txt">
          a) 强行续租收费标准
        </div>
        <div class="txt">
          超过订单还车时间未还车且未取得门店同意并办理续租手续的，视为强行续租，门店有权立即收回车辆。除正常收取超时部分租车费用（含基本保障服务费、车辆整备费及附加服务费）外，另按照超时部分费用（不含基本保障服务费、车辆整备费及附加服务费）的300%收取违约金。若在租车城市以外地区收回车辆，客户须支付异地收车费及其他由强制收车所产生的相关费用。
        </div>
        <div class="txt">b) 提前还车收费标准</div>

        <div class="txt">*非节假日订单</div>
        <div class="txt">
          需提前2小时联系门店，在门店营业时间内办理还车手续，夜间20:00至次日早上08:00办理需支付夜间服务费。
        </div>
        <div class="txt">
          ·提前24小时（含）内还车，费用不退还；
        </div>
        <div class="txt">
          ·提前1天以上还车，需向门店缴清租赁期间的所有费用（租金按照租赁期间日租金标准结算，不享受任何活动），另收取总租金的20%作为退改费。
        </div>

        <div class="txt">*节假日订单</div>
        <div class="txt">
          ·元旦、春节、清明、五一、端午、中秋、国庆提前还车不退费。
        </div>
        <div class="txt">
          c) 续租期间产生的油费及加油服务费、夜间服务费、车辆折旧费、车辆停运损失费、维修押金、随车物品损失费、车辆外观损伤修复/车辆外观件更换费用、道路救援收费、违章处理流程与违约金等其他收费标准与原订单一致，详情请见<span>《预订须知》</span>。
        </div>
        <div class="T-title">4、续租订单取消规则：</div>
        <div class="txt">
          续租成功后，续租订单与原订单合为一个订单；取消续租订单时，原订单也一并取消。
        </div>
        <div class="txt">
            a) 原订单尚未取车已续租成功，取消续租订单需按照页面展示的<span>《取消订单违约金》</span>收取相关费用。
        </div>
        <div class="txt">b) 原订单取车后续租成功，取消续租订单则按照<span>《预订须知》</span>-<span>【提前还车收费标准】</span>执行，元旦、春节、清明、五一、端午、中秋、国庆提前还车不退费。:</div>
      </div>
  </div>
</template>
<script>
console.log('agreementRelet')
export default {
  name: "agreementRelet",
  data(){
    return {
      
    };
  },
  created(){
    console.log('agreementRelet created')
  },
   mounted(){
    console.log('agreementRelet mounted')
  },
};
</script>
<style lang="scss" scoped type="text/scss">
.T-title{
  color: #000;
  font-weight: bold;
}
.agreementRelet {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 24px;
  background-color: #fff;
    .detail {
      padding: 20px 30px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      color: gray;
      overflow: scroll;
      .title {
        margin-top: 20px;
        margin-bottom: 5px;
        font-weight: bold;
        color: #0000ff;
      }
      .name {
        margin-top: 20px;
        margin-bottom: 5px;
        font-weight: bold;
      }
      .txt {
        margin-bottom: 15px;
        line-height: 45px;
        text-align: justify;
        span{  
          font-weight: bold;
        }
      }
      .tab {
        margin-bottom: 15px;
        width: 100%;
        border: solid 1px #000; /*no*/
        box-sizing: border-box;
        .row {
          font-size: 24px;
          display: flex;
          // height: 80px;
          border-bottom: solid 1px #000; /*no*/
          box-sizing: border-box;
          .key {
            padding-left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            box-sizing: border-box;
          }
          .value {
            padding:10px 0;
            padding-left: 10px;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            border-left: solid 1px #000; /*no*/
            box-sizing: border-box;
          }
        }
        .row:last-child {
          border-bottom: none;
        }
      }
    }

}
</style>
